/* eslint-disable no-continue */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  navigateToNextCell,
  onCellFocused,
  tabToNextCell,
} from '../../../SharedModules/AgGridUtilities/suppressNavigation';
import SaveCancelPopup from '../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import {
  CONTACT_TYPE_EXISTING_DEL,
  CONTACT_TYPE_REQ,
} from '../../../SharedModules/Errors/constantMessageData';
import ViewHistoryComponent from '../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import Grid from '../../../SharedModules/Table/TableGridWithFeatures';
import ErrorPopup from '../../Display/NDC/component/ErrorPopup';
import DeleteBoxRender from '../../System/codeTables/Components/deleteBoxRender';
import {
  addContactTypeRow,
  checkDeleteRowPossible,
  deleteContactTypeRow,
  setChildContactTypeError,
  setContactTypeDataChangeTried,
  setContactTypeDataLoading,
  setContactTypeErrorMessage,
  setContactTypeSuccessMessage,
  updateChildUserId,
} from '../store/actions';
import ContactTypeCustomTextField from './ContactTypeCustomTextField';
import { CODE_VALUE_TABLE_HEAD } from './tableHead';

const CodeValueTable = ({
  selectedParentKey,
  fullScreen,
  setFullScreen,
  isReadOnly,
}) => {
  const dispatch = useDispatch();
  const [openDelete, setOpenDelete] = useState(false);
  const [childSeleted, setChildSelected] = useState(null);
  const [errorModal, setErrorModal] = useState(false);
  const [keyValue, setKeyValue] = useState([]);
  const [showViewHistory, setShowViewHistory] = useState(false);

  const dataChangeTried = useSelector(
    (state) => state?.sharedState?.ContactTypeReducer?.dataChangeTried
  );
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );

  const handleBlur = (props, compareContactTypeResult) => {
    dispatch(setContactTypeSuccessMessage(''));
    dispatch(setContactTypeErrorMessage(''));
    if (props && !props.data.isNewRecord) {
      const index = compareContactTypeResult.findIndex(
        (item) => item.codeValueVO.codeValue === props.data.keyTypeCd
      );

      if (index !== -1) {
        const resultIndex = compareContactTypeResult[
          index
        ].contactTypeCdVO.findIndex(
          (item) => item.contactTypeCd === props.data.contactTypeCd
        );
        if (resultIndex !== -1) {
          const result =
            compareContactTypeResult[index].contactTypeCdVO[resultIndex];

          if (
            props.data.longDescr !== result.longDescr ||
            props.data.shortDescr !== result.shortDescr ||
            props.data.dispSeq !== result.dispSeq
          ) {
            dispatch(updateChildUserId(index, resultIndex, logInUser));
          } else {
            dispatch(
              updateChildUserId(
                index,
                resultIndex,
                result.lastUpdateUserId || logInUser
              )
            );
          }
        }
      }
    }
    dispatch(setContactTypeDataChangeTried(Math.random()));

    resetSuccessMessage();
  };

  const addRow = () => {
    resetSuccessMessage();
    const isEmptyRowExists = selectedParentKey.contactTypeCdVO.find(
      (x) => !x.contactTypeCd
    );
    if (isEmptyRowExists) {
      dispatch(setContactTypeErrorMessage(CONTACT_TYPE_REQ));
      return;
    }
    dispatch(setContactTypeErrorMessage(''));
    dispatch(addContactTypeRow(selectedParentKey, logInUser));
  };

  const handleDeleteRow = () => {
    dispatch(deleteContactTypeRow(childSeleted.data, logInUser));
    handleBlur();
    resetSuccessMessage();
    setOpenDelete(false);
  };

  const onDeleteRow = async (childSeletedDel) => {
    if (!childSeletedDel) {
      setErrorModal(true);
    } else if (childSeletedDel.data.isNewRecord) {
      dispatch(setContactTypeErrorMessage(''));
      setOpenDelete(true);
    } else {
      dispatch(setContactTypeDataLoading(true));
      const response = await checkDeleteRowPossible(childSeletedDel.data);
      dispatch(setContactTypeDataLoading(false));
      if (response) {
        dispatch(setContactTypeErrorMessage(''));
        setOpenDelete(true);
      } else {
        dispatch(setContactTypeErrorMessage(CONTACT_TYPE_EXISTING_DEL));
        setOpenDelete(false);
      }
    }
  };

  const resetSuccessMessage = () => {
    dispatch(setContactTypeSuccessMessage(''));
  };

  const checkContactType = () => {
    const data =
      (selectedParentKey &&
        selectedParentKey.contactTypeCdVO.filter((item) => !item.deleteFlag)) ||
      [];
    if (data.length > 0) {
      const emptyFilterArr = data.filter(
        (item) => item.contactTypeCd === '' || item.contactTypeCd.trim() === ''
      );

      if (emptyFilterArr.length > 0) {
        dispatch(setChildContactTypeError(true));
        dispatch(setContactTypeErrorMessage(CONTACT_TYPE_REQ));
      } else {
        let duplicateFound = false;
        for (let i = 0; i < data.length; i += 1) {
          if (data[i].isNewRecord) {
            for (let j = i + 1; j < data.length; j += 1) {
              if (
                !data[j].deleteFlag &&
                data[i].contactTypeCd === data[j].contactTypeCd
              ) {
                duplicateFound = true;
                dispatch(setChildContactTypeError(true));
                dispatch(
                  setContactTypeErrorMessage(
                    `Contact Type Cd already exists at row #${i + 1} and #${
                      j + 1
                    }`
                  )
                );
                break;
              } 
              // else if (
              //   !data[j].deleteFlag &&
              //   data[i].dispSeq === data[j].dispSeq
              // ) {
              //   duplicateFound = true;
              //   dispatch(setChildContactTypeError(true));
              //   dispatch(
              //     setContactTypeErrorMessage(
              //       `Display sequence number #${data[j].dispSeq} already exists for the Key type ${data[i].keyTypeCd}`
              //     )
              //   );
              //   break;
              // }
            }
          } else {
            continue;
          }

          if (duplicateFound) {
            break;
          }
        }

        if (!duplicateFound) {
          dispatch(setChildContactTypeError(false));
          dispatch(setContactTypeErrorMessage(''));
        }
      }
    } else {
      dispatch(setChildContactTypeError(false));
      dispatch(setContactTypeErrorMessage(''));
    }
  };

  useEffect(() => {
    checkContactType();
  }, [dataChangeTried]);

  const handleFullScreenView = () => {
    setFullScreen(!fullScreen);
  };

  const handleViewHistory = (gridApi) => {
    const selectedRow = gridApi.getSelectedRows()?.[0];
    if (selectedRow !== undefined) {
      setShowViewHistory(true);
      setKeyValue({
        CONTACT_TYPE_CD: `${selectedRow?.contactTypeCd}`,
        KEY_TYPE_CD: `${selectedRow?.keyTypeCd}`,
      });
    }
  };

  return (
    <div
      className={`table-container fourRecords no-border mt-${
        fullScreen ? 1 : 5
      }`}
    >
      <Grid
        gridHeight={fullScreen ? '70vh' : 270}
        rowData={
          (selectedParentKey &&
            selectedParentKey.contactTypeCdVO.filter(
              (item) => !item.deleteFlag
            )) ||
          []
        }
        defaultCol={{ editable: false }}
        columnDefs={CODE_VALUE_TABLE_HEAD}
        frameworkComponents={{
          textFieldComponent: (props) => (
            <ContactTypeCustomTextField
              {...props}
              validateBtnDisable={handleBlur}
              isReadOnly={isReadOnly}
            />
          ),
          deleteBoxRenderer: (props) => (
            <DeleteBoxRender
              {...props}
              isReadOnly={isReadOnly}
              onClick={(data) => {
                dispatch(setContactTypeSuccessMessage(''));
                setChildSelected(data);
                onDeleteRow(data);
              }}
            />
          ),
        }}
        fullScreenView={fullScreen}
        handleFullScreenViewClick={handleFullScreenView}
        navigateToNextCell={navigateToNextCell}
        // tabToNextCell={tabToNextCell}
        enterMovesDown
        suppressCellFocus
        onCellFocused={onCellFocused}
        exportFile
        data-testid='onEditingStopped'
        fileName='Contact Type Table'
        disableAddAction={isReadOnly}
        addTxt='Add Contact Type'
        addAction={addRow}
        handleViewHistory={handleViewHistory}
      />
      <SaveCancelPopup
        open={openDelete}
        title='Delete'
        onConfim={() => {
          if (childSeleted) {
            handleDeleteRow();
          }
        }}
        onCancel={() => {
          setChildSelected(null);
          setOpenDelete(false);
        }}
        moduleName='the selected record'
      />

      {errorModal && (
        <ErrorPopup
          errorPopupMessage='Please select a row to delete.'
          onClose={() => setErrorModal(false)}
        />
      )}

      {showViewHistory ? (
        <ViewHistoryComponent
          setShowViewHistory={setShowViewHistory}
          tableName='CONTACT_TYPE_CD'
          keyValue={keyValue}
          columnNames='SHORT_DESCR,LONG_DESCR,DIST_SEQ'
        />
      ) : null}
    </div>
  );
};
export default CodeValueTable;
